import PageMeta from "../../components/common/PageMeta";
import GuestProfiles from "../../components/hotel/GuestProfiles";

export default function GuestProfilesPage() {
  return (
    <>
      <PageMeta
        title="Guest Profiles - SelfServe"
        description="SelfServe Guest Profiles Dashboard"
      />
      <div className="col-span-12">
        <GuestProfiles />
      </div>
    </>
  );
}
